/**
 * Router-aware link: internal paths use React Router; external use <a>.
 */
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";

function isExternal(href) {
  if (href == null || typeof href !== "string") return false;
  return (
    href.startsWith("http://") ||
    href.startsWith("https://") ||
    href.startsWith("//") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:") ||
    href.startsWith("#")
  );
}

const Link = forwardRef(function Link(
  {
    href,
    prefetch,
    replace,
    scroll,
    shallow,
    children,
    ...props
  },
  ref,
) {
  void prefetch;
  void scroll;
  void shallow;
  const to = href ?? "/";

  if (isExternal(to)) {
    return (
      <a ref={ref} href={to} {...props}>
        {children}
      </a>
    );
  }

  return (
    <RouterLink ref={ref} to={to} replace={replace} {...props}>
      {children}
    </RouterLink>
  );
});

export default Link;
